export default __webpack_public_path__ + "ccac23a.png";